const initState = {
  userPermissions: [],
  userDetails: {},
  providerDetails: {}
}

export default function appReducer(state = initState, action) {
  switch (action.type) {
    default:
      return state
  }
}
